import React, { useState, useEffect, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

export interface YADKModel {
	environment?: {
		app: {
			id: string;
		};
		browser: {
			lang: string;
		};
		i18n: {
			lang: string;
			tld: string;
		};
		payload: string;
	};
	features: {
		LoadingAPI: {
			ready: any;
		}
	};
}

export const YsdkContext = createContext<YADKModel | null>(null);

interface YsdkProviderProviderProps {
	children: React.ReactNode;
}


export const YsdkProvider = ({ children }: YsdkProviderProviderProps) => {
	const { i18n } = useTranslation();
	const [ysdk, setYsdk] = useState(null);

	useEffect((): void => {
		const initYsdk = async () => {
			// @ts-ignore
			const ysdkInstance = await window.YaGames.init();
			setYsdk(ysdkInstance);

			const lang = ysdkInstance.environment.i18n.lang;
			i18n.changeLanguage(lang).then();

			// @ts-ignore
			ysdk.features.LoadingAPI.ready();
		};

		initYsdk();
	}, []);

	return (
		<YsdkContext.Provider value={ysdk}>
			{children}
		</YsdkContext.Provider>
	);
};
